export const validation = {
	maxValue: "La valeur dépasse le maximum autorisé",

	// Sale type validation
	saleType: {
		required: "Le type de vente est obligatoire",
		invalid: "Type de vente invalide",
	},
	unitOfMeasure: {
		required: "L'unité de mesure est obligatoire",
		requiredForVariable: "L'unité de mesure est obligatoire pour le prix variable",
		invalid: "Unité de mesure invalide",
	},
	price: {
		required: "Le prix est obligatoire",
		invalid: "Le prix est obligatoire",
		min: "Le prix doit être supérieur ou égal à 0",
	},
	quantity: {
		required: "La quantité est obligatoire",
		invalid: "Quantité invalide",
		min: "La quantité doit être supérieure à 0",
		max: "La quantité doit être inférieure à 10 000",
	},

	// Fiscal data validation
	ncm: {
		required: "NCM est obligatoire",
		invalid: "NCM doit contenir entre 4 et 8 chiffres",
	},
	cest: {
		required: "CEST est obligatoire",
		invalid: "CEST doit contenir exactement 7 chiffres",
	},
	fiscalProfile: {
		required: "Le profil fiscal est obligatoire",
		invalid: "Profil fiscal invalide",
		min: "Le profil fiscal est obligatoire",
	},
	fiscalGroup: {
		required: "Le groupe fiscal est obligatoire",
		invalid: "Groupe fiscal invalide",
		min: "Le groupe fiscal est obligatoire",
	},
	fiscalIcmsBaseCalculoRetSt: {
		required: "Champ obligatoire",
		min: "La valeur doit être supérieure à zéro",
	},
	fiscalIcmsValorSubstituto: {
		required: "Champ obligatoire",
	},
	fiscalIcmsAliquotaFinal: {
		required: "Champ obligatoire",
		min: "La valeur doit être supérieure à zéro",
	},

	// General fields
	name: {
		required: "Le nom est obligatoire",
		min: "Le nom est obligatoire",
		max: "Le nom ne doit pas dépasser 100 caractères",
	},
	systemProduct: {
		required: "Le produit système est obligatoire",
	},
	category: {
		required: "La catégorie est obligatoire",
		min: "La catégorie est obligatoire",
	},
	sku: {
		invalid:
			"Le SKU doit contenir uniquement des lettres, des chiffres, des tirets et des underscores",
	},
	preparationTime: {
		int: "Le temps de préparation doit être un nombre entier",
		min: "Le temps de préparation doit être supérieur à 0",
		max: "Le temps de préparation doit être inférieur à 1440 minutes (24 heures)",
	},
	description: {
		max: "La description ne doit pas dépasser 500 caractères",
	},
	releasePrice: {
		min: "Le prix de cession doit être supérieur ou égal à 0",
		required: "Le prix de cession est obligatoire",
		maxPrice: "Le prix de cession ne peut pas être supérieur au prix du produit",
	},

	// Stock validation
	isStockable: {
		required: "Champ obligatoire",
		invalid: "Valeur invalide",
	},
	stockControlledBy: {
		required: "Le stock contrôlé par est obligatoire lorsque le produit est stockable",
		invalid: "Unité de stock invalide",
	},
	conversionQuantity: {
		required: "La quantité de conversion est obligatoire",
		min: "La quantité doit être supérieure à 0",
		max: "La quantité de conversion doit être inférieure à 10 000",
	},
	conversionUnit: {
		required: "L'unité de conversion est obligatoire",
		invalid: "Unité de conversion invalide",
	},

	// Image validation
	image: {
		required: "L'image est obligatoire",
		invalid: "Image invalide",
	},

	// Mountable product validation
	mountable: {
		title: {
			required: "Le titre de l'étape est obligatoire",
			min: "Le titre de l'étape est obligatoire",
		},
		pricing: {
			required: "La méthode de tarification est obligatoire",
			invalid: "Méthode de tarification invalide",
		},
		min: {
			required: "La valeur minimale est obligatoire",
			minValue: "La valeur minimale doit être supérieure ou égale à 0",
		},
		max: {
			required: "La valeur maximale est obligatoire",
			minValue: "La valeur maximale doit être supérieure à 0",
			minGreaterThanMin: "La valeur maximale doit être supérieure ou égale au minimum",
		},
		items: {
			min: "Il doit y avoir au moins un article dans l'étape",
		},
		item: {
			productId: {
				required: "L'article est obligatoire",
				min: "L'article est obligatoire",
				duplicate: "Cet article a déjà été ajouté à cette étape",
			},
			price: {
				min: "Le prix doit être supérieur ou égal à 0",
			},
			storageCount: {
				required: "La quantité déduite est obligatoire",
				minValue: "La quantité déduite doit être supérieure à 0",
			},
		},
	},
};
